import { MatDialogRef } from '@angular/material/dialog';
import { AutomotiveAftermarketProfileModel, AutomotiveAftermarketProfileDetails } from '../models';

export class AutomotiveAftermarketProfileItemLoad {
  public static readonly type = '[AutomotiveAftermarketProfileItem] Load';
  constructor(public payload: number) {}
}

export class AutomotiveAftermarketProfileItemCreate {
  public static readonly type = '[AutomotiveAftermarketProfileItem] Create';
  constructor(
    public payload: {
      dialog: MatDialogRef<unknown>;
      profile: Partial<AutomotiveAftermarketProfileModel>;
    },
  ) {}
}

export class AutomotiveAftermarketProfileItemSave {
  public static readonly type = '[AutomotiveAftermarketProfileItem] Save';
  constructor(public payload: Partial<AutomotiveAftermarketProfileDetails>) {}
}

export class AutomotiveAftermarketProfileItemUpdate {
  public static readonly type = '[AutomotiveAftermarketProfileItem] Update';
  constructor(public payload: Partial<AutomotiveAftermarketProfileModel>) {}
}

export class AutomotiveAftermarketProfileItemClone {
  public static readonly type = '[AutomotiveAftermarketProfileItem] Clone';
  constructor(public payload: Partial<AutomotiveAftermarketProfileDetails>) {}
}

export class AutomotiveAftermarketProfileItemDelete {
  public static readonly type = '[AutomotiveAftermarketProfileItem] Delete';
  constructor(public payload: { dialog: MatDialogRef<unknown>; profileId: number }) {}
}

export class AutomotiveAftermarketProfileItemInitialState {
  public static readonly type = '[AutomotiveAftermarketProfileItem] Set Initial State';
}
